import { FunctionComponent } from 'react'

interface MoveViewProps {
  currentCount: number
  totalCount: number
  callback?: () => void
}

const MoveView: FunctionComponent<MoveViewProps> = (props) => {
  const getCountString = () => {
    return `${props.currentCount}/${props.totalCount}`
  }

  return (
    <div className="absolute w-full h-full top-0 left-0 pointer-events-none">
      <div className="pointer-events-auto absolute bottom-0 w-full flex justify-center text-center">
        <div className='relative'>
          <button className="btn--blue w-[360px] m-[15px] mb-[20px] mt-[0px] z-[2] relative"
                  onClick={props.callback}>Move
          </button>
          <div className='flex justify-center absolute inset-0 z-[1]'>
            <div
              className='flex text-[#0350A8] text-lg justify-center w-[60px] h-[60px] bg-[#D9D9D9] rounded-full -mt-8'>
              <span className='mt-1'>{getCountString()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MoveView
